export const mailAppName = "JAa";
export default {mailAppName};